import { FIELD, STUDENT_GENDER } from "../../../../values/dropdownItems";
import boyStudentIcon from "../../../../../assets/images/boy-student.png";
import girlStudentIcon from "../../../../../assets/images/girl-student.png";

interface IStudentInfo {
  avatar?: string;
  firstName?: string;
  lastName?: string;
  nationalCode?: string;
  grade?: string;
  field?: string;
  gender?: string;
  disability?: boolean;
}

const StudentInfoMap = ({
  avatar,
  firstName,
  lastName,
  nationalCode,
  grade,
  field,
  gender,
  disability,
}: IStudentInfo) => {
  return (
    <div className="description">
      <div>
        {avatar ? (
          <img src={avatar} />
        ) : (
          <img src={gender === "MALE" ? boyStudentIcon : girlStudentIcon} />
        )}
      </div>
      {(firstName || lastName) && (
        <p>
          <i className="fa-light fa-user"></i>
          {(firstName ? firstName : "") + " " + (lastName ? lastName : "")}
          {gender &&
            " (" +
              STUDENT_GENDER?.find((item) => item.value === gender)?.name +
              ")"}
        </p>
      )}

      {nationalCode && (
        <p>
          <i className="fa-light fa-address-card"></i>
          {nationalCode}
        </p>
      )}

      {grade && (
        <p>
          <i className="fa-light fa-graduation-cap"></i>
          {grade}
          {field &&
            " (" + FIELD.find((item) => item.value === field)?.name + ")"}
        </p>
      )}

      {disability && (
        <p>
          <i className="fal fa-wheelchair"></i>دارای ناتوانی
        </p>
      )}
    </div>
  );
};

export default StudentInfoMap;
